import React from "react";
import moment from "moment";
import {
    ContentUkm,
    GetTimeAltResponse,
    GetUkmResponse,
    UserResponse,
} from "../../constants/types";
import { getLocalUkmId } from "../../utils/handleChangeUkmId";

export default function useSelectedUkm(
    user: UserResponse["data"] | undefined,
    ukm: GetUkmResponse["data"] | undefined,
    time?: GetTimeAltResponse,
) {
    const ukmId = React.useMemo(() => {
        if (!user?.userId) return null;
        return getLocalUkmId(user.userId);
    }, [user?.userId]);

    const ukmData = React.useMemo(() => {
        if (ukmId) return ukm?.content.find((item) => item.id === ukmId);
        return ukm?.content[0];
    }, [ukm?.content, ukmId]);

    const isSudahJatuhTempo = React.useMemo(() => {
        if (!time?.dateTime || !ukmData?.pembayaranBerikutnya) return false;
        return moment(time.dateTime).isAfter(ukmData.pembayaranBerikutnya);
    }, [time?.dateTime, ukmData?.pembayaranBerikutnya]);

    const isUkmTidakAktif = React.useMemo(() => {
        if (!ukmData) return false;
        return (
            ukmData.isActive === 0 ||
            ukmData.isActive === null ||
            ukmData.lewatTempoPro === 1 ||
            isSudahJatuhTempo ||
            ukmData.isPro !== 1
        );
    }, [isSudahJatuhTempo, ukmData]);

    return {
        ukmId,
        ukmData: ukmData as ContentUkm | undefined,
        isSudahJatuhTempo,
        isUkmTidakAktif,
    };
}
